import React from 'react';
import Helmet from 'react-helmet';
import './legal.css';

const TermsPage = () => (
  <div className="legal-shell">
    <Helmet>
      <title>Website Terms | Coetic X</title>
      <meta
        name="description"
        content="Coetic X website terms outlining acceptable use, content rights, and limitations."
      />
    </Helmet>
    <div className="legal-card">
      <div className="legal-meta">
        <span className="legal-eyebrow">Legal</span>
        <h1>Website Terms</h1>
        <p className="legal-date">Effective: Jan 1, 2026</p>
        <p className="legal-lead">
          These terms govern your access to and use of the Coetic X website. By using this site, you
          agree to comply with the conditions below.
        </p>
      </div>

      <section className="legal-section">
        <h2>Use of the site</h2>
        <p>
          You may use this site for informational purposes and to contact Coetic X. You agree not to
          misuse the site, interfere with its operation, or attempt unauthorized access.
        </p>
      </section>

      <section className="legal-section">
        <h2>Intellectual property</h2>
        <p>
          All content on this site, including text, visuals, and branding, is owned by Coetic X or its
          licensors and may not be copied or reused without written permission.
        </p>
      </section>

      <section className="legal-section">
        <h2>Third-party links</h2>
        <p>
          This site may link to third-party resources. We are not responsible for the content or
          practices of those sites.
        </p>
      </section>

      <section className="legal-section">
        <h2>Disclaimer</h2>
        <p>
          The site is provided on an \"as is\" basis. We do not guarantee accuracy, availability, or
          suitability for any specific purpose.
        </p>
      </section>

      <section className="legal-section">
        <h2>Limitation of liability</h2>
        <p>
          Coetic X is not liable for indirect, incidental, or consequential damages arising from use of
          this site.
        </p>
      </section>

      <section className="legal-section">
        <h2>Changes</h2>
        <p>
          We may update these terms as our services evolve. Continued use of the site after changes
          indicates acceptance of the updated terms.
        </p>
      </section>

      <section className="legal-section">
        <h2>Contact</h2>
        <p>
          For questions about these terms, contact us at&nbsp;
          <a href="mailto:arber@coetic-x.com">arber@coetic-x.com</a>.
        </p>
      </section>
    </div>
  </div>
);

export default TermsPage;
